module.exports = __webpack_public_path__ + "img/Pic_Text_IONE_Title.738fff80.png";